import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser, AdminState } from './types';
import { ITimeLineItem } from '../../../containers/chat/slice/types';
import { ChatSession } from '../../MainLayout/slice/types';

export const initialState: AdminState = {
  isSidebarOpen: true,
  currentUser: null,
  isCurrentUserLoading: false,
  isLogoutInProgress: false,
  isAuthenticated: true,
  selectedSessionIsdToView: null,
  sessionTimelineItems: [],
  isSessionTimelineLoading: false,
  selectedUserToView: null,
  isUserSessionsLoading: false,
  userSessions: [],
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    getCurrentUser(state) {
      state.isCurrentUserLoading = true;
    },
    getCurrentUserSucceeded(state, action: PayloadAction<IUser>) {
      state.currentUser = action.payload;
      state.isCurrentUserLoading = false;
      
    },
    getCurrentUserFailed(state) {
      state.isCurrentUserLoading = false;
    },
    
    toggleSidebar(state, action: PayloadAction<boolean | undefined>) {
      state.isSidebarOpen = action.payload !== undefined ? action.payload : !state.isSidebarOpen;
    },

   
    logout(state) {
      state.isLogoutInProgress = true;
    },
    logoutSucceeded(state) {
      state.isLogoutInProgress = false;
      state.currentUser = null;
    },
    logoutFailed(state) {
      state.isLogoutInProgress = false;
    },
   
    setIsAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
    setSelectedSessionIsdToView(state, action: PayloadAction<string | null>) {
      state.selectedSessionIsdToView = action.payload;
    },
    setSelectedUserToView(state, action: PayloadAction<string | null>) {
      state.selectedUserToView = action.payload;
    },
    getSessionTimeline(state, _action: PayloadAction<string>) {
      state.isSessionTimelineLoading = true;
      state.sessionTimelineItems = [];
    },
    getSessionTimelineSucceeded(state, action: PayloadAction<ITimeLineItem[]>) {
      state.sessionTimelineItems = action.payload;
      state.isSessionTimelineLoading = false;
    },
    getSessionTimelineFailed(state) {
      state.isSessionTimelineLoading = false;
      state.sessionTimelineItems = [];
    },
    clearSessionTimeline(state) {
      state.isSessionTimelineLoading = false;
      state.sessionTimelineItems = [];
    },
    getUserSessions(state, _action: PayloadAction<{productId: string, userId: string}>) {
      state.isUserSessionsLoading = true;
      state.userSessions = [];
    },
    getUserSessionsSucceeded(state, action: PayloadAction<ChatSession[]>) {
      state.userSessions = action.payload;
      state.isUserSessionsLoading = false;
    },
    getUserSessionsFailed(state) {
      state.isUserSessionsLoading = false;
      state.userSessions = [];
    },
    clearUserSessions(state) {
      state.isUserSessionsLoading = false;
      state.userSessions = [];
    },
  },
  extraReducers: (builder) => {
    // builder.addCase(subscriptionActions.reSubscribeSucceeded, (state, action) => {
    //     return { ...state, subscription: action.payload, ...(action.payload.customer ? { currentUser: action.payload.customer } : {}) };
    // });
  },
});
export const { actions: adminActions } = adminSlice;
export const useAdminSlice = () => {
  return { actions: adminSlice.actions };
};
